import * as z from "zod/mini";
import { devBaseSchema, parseFrameConfig, themeBaseSchema } from "../../lib/parse-frame-config";

const publicSchema = z.extend(themeBaseSchema, {
  channelId: z._default(z.string(), ""),
  challengeToken: z._default(z.string(), ""),
  clientToken: z._default(z.string(), ""),
  // "true" hands a resolved wallet buy back to the partner's own pay button (`resolved`) instead
  // of showing the in-frame sheet. Same opt-in as Orion's challenge frame.
  resume: z.optional(z.string()),
});

const devSchema = z.object({
  ...devBaseSchema.shape,
  forceError: z._default(z.string(), ""),
});

const KNOWN_KEYS = new Set([...Object.keys(publicSchema.shape), ...Object.keys(devSchema.shape)]);

export type ChallengeConfig = z.infer<typeof publicSchema> & z.infer<typeof devSchema>;

export function parseConfig(search?: string): ChallengeConfig {
  const { config, devConfig } = parseFrameConfig({
    publicSchema,
    devSchema,
    knownKeys: KNOWN_KEYS,
    search,
  });
  return { ...config, ...devConfig };
}
